module.exports = __webpack_public_path__ + "static/zoho-108d24109b1443cadc3e6d704b5611ca.png";